import { filterClasses } from "@swivl-mono/helpers";
import { NotificationType } from "@swivl-mono/types";
import { AnimatePresence, motion } from "motion/react";
import { type CSSProperties } from "react";
import "./Toast.scss";
import { getToastClassNamesConfig } from "./ToastClassNamesConfig";
import { ToastGeneric } from "./ToastGeneric";
import { ToastData } from "./ToastRoot";
import { ToastEscalation } from "./ToastEscalation";

export interface BaseToastProps {
  duration?: number;
  style?: CSSProperties;
  data: ToastData;
};

export enum ToastVariant {
  DEFAULT = "default",
  ERROR = "error",
  SUCCESS = "success",
}

export function ToastWrapper(props: BaseToastProps) {
  const { duration = 5000, style, data } = props

  const toastInternalClassNames = data.escalation ? getToastClassNamesConfig(NotificationType.ESCALATION, data.escalation.channel) : getToastClassNamesConfig(NotificationType.TOAST, ToastVariant.DEFAULT);

  const ToastContents = () => {
    if (data.escalation) {
      return <ToastEscalation escalation={data.escalation} />;
    } else if (data.notification) {
      return <ToastGeneric notification={data.notification} />;
    }
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        className={filterClasses(
          `${toastInternalClassNames.wrapper}`,
          "shadow-lg flex border-2 justify-between rounded-lg p-4 h-[74px] items-center w-full"
        )}
        initial={{ opacity: 0, x: 200 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 200 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        style={style}
      >
        <ToastContents />
      </motion.div>
    </AnimatePresence>
  )
}


